/**
 * 销售管理 选车车型,车系 mock
 * http://mockjs.com/
 url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'

let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'
Mock.mock(/auctions\/car_models\/brands$/, 'get' + mockSwitch, {
  'brands': {
    'A': [
      {
        'id': 1,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_9_55.png',
        'name': '奥迪'
      },
      {
        'id': 2,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_97_55.png',
        'name': '阿斯顿·马丁'
      },
      {
        'id': 3,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_92_55.png',
        'name': '阿尔法·罗密欧'
      },
      {
        'id': 4,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_151_55.png',
        'name': '阿尔特'
      },
      {
        'id': 5,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_180_55.png',
        'name': 'AC Schnitzer'
      },
      {
        'id': 6,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_12_55.png',
        'name': '奥克斯'
      },
      {
        'id': 7,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_272_55.png',
        'name': 'ARCFOX'
      },
      {
        'id': 8,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_228_55.png',
        'name': 'Artega'
      }
    ],
    'B': [
      {
        'id': 9,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_26_55.png',
        'name': '本田'
      },
      {
        'id': 10,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_2_55.png',
        'name': '奔驰'
      },
      {
        'id': 11,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_3_55.png',
        'name': '宝马'
      },
      {
        'id': 12,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_127_55.png',
        'name': '别克'
      },
      {
        'id': 13,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_157_55.png',
        'name': '宝骏'
      },
      {
        'id': 14,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_5_55.png',
        'name': '标致'
      },
      {
        'id': 15,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_15_55.png',
        'name': '比亚迪'
      },
      {
        'id': 16,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_82_55.png',
        'name': '保时捷'
      },
      {
        'id': 17,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_211_55.png',
        'name': '北汽幻速'
      },
      {
        'id': 18,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_59_55.png',
        'name': '奔腾'
      },
      {
        'id': 19,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_163_55.png',
        'name': '北京'
      },
      {
        'id': 20,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_236_55.png',
        'name': '宝沃'
      },
      {
        'id': 21,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_195_55.png',
        'name': '北汽绅宝'
      },
      {
        'id': 22,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_85_55.png',
        'name': '宾利'
      },
      {
        'id': 23,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_14_55.png',
        'name': '北汽制造'
      },
      {
        'id': 24,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_168_55.png',
        'name': '北汽威旺'
      },
      {
        'id': 25,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_216_55.png',
        'name': '北汽新能源'
      },
      {
        'id': 26,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_263_55.png',
        'name': '比速汽车'
      },
      {
        'id': 27,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_172_55.png',
        'name': '巴博斯'
      },
      {
        'id': 28,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_135_55.png',
        'name': '布加迪'
      },
      {
        'id': 29,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_184_55.png',
        'name': '保斐利'
      },
      {
        'id': 30,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_261_55.png',
        'name': '北汽瑞丽'
      },
      {
        'id': 31,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_68_55.png',
        'name': '宝龙'
      }
    ],
    'C': [
      {
        'id': 32,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_136_55.png',
        'name': '长安'
      },
      {
        'id': 33,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_159_55.png',
        'name': '长安商用'
      },
      {
        'id': 34,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_21_55.png',
        'name': '长城'
      },
      {
        'id': 35,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_129_55.png',
        'name': '昌河'
      },
      {
        'id': 36,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_230_55.png',
        'name': '长安跨越'
      },
      {
        'id': 37,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_221_55.png',
        'name': '成功'
      },
      {
        'id': 38,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_231_55.png',
        'name': '长城华冠'
      },
      {
        'id': 39,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_250_55.png',
        'name': '长久汽车'
      }
    ],
    'D': [
      {
        'id': 40,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_8_55.png',
        'name': '大众'
      },
      {
        'id': 42,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_115_55.png',
        'name': '东风风行'
      },
      {
        'id': 43,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_29_55.png',
        'name': '东南'
      },
      {
        'id': 44,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_253_55.png',
        'name': '东风风光'
      },
      {
        'id': 45,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_141_55.png',
        'name': '东风风神'
      },
      {
        'id': 46,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_179_55.png',
        'name': 'DS'
      },
      {
        'id': 47,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_113_55.png',
        'name': '道奇'
      },
      {
        'id': 48,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_205_55.png',
        'name': '东风小康'
      },
      {
        'id': 49,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_235_55.png',
        'name': '东风·郑州日产'
      },
      {
        'id': 50,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_197_55.png',
        'name': '东风风度'
      },
      {
        'id': 51,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_215_55.png',
        'name': '东风御风'
      },
      {
        'id': 52,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_27_55.png',
        'name': '东风'
      },
      {
        'id': 53,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_106_55.png',
        'name': '大宇'
      },
      {
        'id': 54,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_256_55.png',
        'name': '东风风诺'
      },
      {
        'id': 55,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_66_55.png',
        'name': '大迪'
      },
      {
        'id': 56,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_192_55.png',
        'name': '底特律电动车'
      }
    ],
    'F': [
      {
        'id': 57,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_7_55.png',
        'name': '丰田'
      },
      {
        'id': 58,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_17_55.png',
        'name': '福特'
      },
      {
        'id': 59,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_128_55.png',
        'name': '福田'
      },
      {
        'id': 60,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_91_55.png',
        'name': '法拉利'
      },
      {
        'id': 61,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_40_55.png',
        'name': '菲亚特'
      },
      {
        'id': 62,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_67_55.png',
        'name': '福迪'
      },
      {
        'id': 63,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_208_55.png',
        'name': '福汽启腾'
      },
      {
        'id': 64,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_199_55.png',
        'name': '飞驰商务车'
      },
      {
        'id': 65,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_187_55.png',
        'name': 'Faralli Mazzanti'
      },
      {
        'id': 66,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_164_55.png',
        'name': '菲斯克'
      },
      {
        'id': 67,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_61_55.png',
        'name': '富奇'
      }
    ],
    'G': [
      {
        'id': 68,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_147_55.png',
        'name': '广汽传祺'
      },
      {
        'id': 69,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_182_55.png',
        'name': '观致汽车'
      },
      {
        'id': 70,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_109_55.png',
        'name': 'GMC'
      },
      {
        'id': 71,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_63_55.png',
        'name': '广汽吉奥'
      },
      {
        'id': 72,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_110_55.png',
        'name': '光冈'
      },
      {
        'id': 73,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_252_55.png',
        'name': '广汽中兴'
      },
      {
        'id': 74,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_237_55.png',
        'name': 'GTA'
      },
      {
        'id': 75,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_133_55.png',
        'name': '广汽日野'
      }
    ],
    'H': [
      {
        'id': 76,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_196_55.png',
        'name': '哈弗'
      },
      {
        'id': 77,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_32_55.png',
        'name': '海马'
      },
      {
        'id': 78,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_58_55.png',
        'name': '红旗'
      },
      {
        'id': 79,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_259_55.png',
        'name': '汉腾'
      },
      {
        'id': 80,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_112_55.png',
        'name': '华泰'
      },
      {
        'id': 81,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_108_55.png',
        'name': '悍马'
      },
      {
        'id': 82,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_52_55.png',
        'name': '黄海'
      },
      {
        'id': 83,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_31_55.png',
        'name': '哈飞'
      },
      {
        'id': 84,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_225_55.png',
        'name': '华颂'
      },
      {
        'id': 85,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_251_55.png',
        'name': '华泰新能源'
      },
      {
        'id': 86,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_149_55.png',
        'name': '海马商用车'
      },
      {
        'id': 87,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_45_55.png',
        'name': '汇众'
      },
      {
        'id': 88,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_170_55.png',
        'name': '海格'
      },
      {
        'id': 89,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_44_55.png',
        'name': '华普'
      },
      {
        'id': 90,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_181_55.png',
        'name': '恒天汽车'
      },
      {
        'id': 91,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_124_55.png',
        'name': '黑豹'
      },
      {
        'id': 92,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_262_55.png',
        'name': '华凯'
      },
      {
        'id': 93,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_70_55.png',
        'name': '航天圆通'
      },
      {
        'id': 94,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_119_55.png',
        'name': '汉江'
      }
    ],
    'HOT': [
      {
        'id': 1,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_9_55.png',
        'name': '奥迪'
      },
      {
        'id': 9,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_26_55.png',
        'name': '本田'
      },
      {
        'id': 10,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_2_55.png',
        'name': '奔驰'
      },
      {
        'id': 11,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_3_55.png',
        'name': '宝马'
      },
      {
        'id': 12,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_127_55.png',
        'name': '别克'
      },
      {
        'id': 14,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_5_55.png',
        'name': '标致'
      },
      {
        'id': 15,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_15_55.png',
        'name': '比亚迪'
      },
      {
        'id': 40,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_8_55.png',
        'name': '大众'
      },
      {
        'id': 57,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_7_55.png',
        'name': '丰田'
      },
      {
        'id': 58,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_17_55.png',
        'name': '福特'
      },
      {
        'id': 138,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_18_55.png',
        'name': '马自达'
      },
      {
        'id': 160,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_30_55.png',
        'name': '日产'
      },
      {
        'id': 164,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_10_55.png',
        'name': '斯柯达'
      },
      {
        'id': 195,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_13_55.png',
        'name': '现代'
      },
      {
        'id': 196,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_49_55.png',
        'name': '雪佛兰'
      },
      {
        'id': 197,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_6_55.png',
        'name': '雪铁龙'
      }
    ],
    'J': [
      {
        'id': 95,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_34_55.png',
        'name': '吉利汽车'
      },
      {
        'id': 96,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_4_55.png',
        'name': 'Jeep'
      },
      {
        'id': 97,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_35_55.png',
        'name': '江淮'
      },
      {
        'id': 98,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_98_55.png',
        'name': '捷豹'
      },
      {
        'id': 99,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_39_55.png',
        'name': '金杯'
      },
      {
        'id': 100,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_37_55.png',
        'name': '江铃'
      },
      {
        'id': 101,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_57_55.png',
        'name': '金龙'
      },
      {
        'id': 102,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_152_55.png',
        'name': '九龙'
      },
      {
        'id': 103,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_38_55.png',
        'name': '江南'
      },
      {
        'id': 104,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_224_55.png',
        'name': '江铃集团轻汽'
      },
      {
        'id': 105,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_161_55.png',
        'name': '金旅客车'
      },
      {
        'id': 106,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_74_55.png',
        'name': '金程'
      },
      {
        'id': 107,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_121_55.png',
        'name': '吉林江北'
      }
    ],
    'K': [
      {
        'id': 108,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_107_55.png',
        'name': '凯迪拉克'
      },
      {
        'id': 109,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_150_55.png',
        'name': '开瑞'
      },
      {
        'id': 110,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_220_55.png',
        'name': '凯翼'
      },
      {
        'id': 111,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_51_55.png',
        'name': '克莱斯勒'
      },
      {
        'id': 112,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_218_55.png',
        'name': '科瑞斯的'
      },
      {
        'id': 113,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_241_55.png',
        'name': '康迪全球鹰电动汽车'
      },
      {
        'id': 114,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_145_55.png',
        'name': '科尼赛克'
      },
      {
        'id': 115,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_212_55.png',
        'name': 'KTM'
      },
      {
        'id': 116,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_213_55.png',
        'name': '卡威'
      },
      {
        'id': 117,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_188_55.png',
        'name': '卡尔森'
      }
    ],
    'L': [
      {
        'id': 118,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_96_55.png',
        'name': '路虎'
      },
      {
        'id': 119,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_94_55.png',
        'name': '雷克萨斯'
      },
      {
        'id': 120,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_16_55.png',
        'name': '铃木'
      },
      {
        'id': 121,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_153_55.png',
        'name': '猎豹汽车'
      },
      {
        'id': 122,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_95_55.png',
        'name': '林肯'
      },
      {
        'id': 123,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_36_55.png',
        'name': '陆风'
      },
      {
        'id': 124,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_99_55.png',
        'name': '雷诺'
      },
      {
        'id': 125,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_76_55.png',
        'name': '力帆'
      },
      {
        'id': 126,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_86_55.png',
        'name': '兰博基尼'
      },
      {
        'id': 127,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_80_55.png',
        'name': '劳斯莱斯'
      },
      {
        'id': 128,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_229_55.png',
        'name': '雷丁电动'
      },
      {
        'id': 129,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_83_55.png',
        'name': '路特斯'
      },
      {
        'id': 130,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_146_55.png',
        'name': '莲花'
      },
      {
        'id': 131,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_200_55.png',
        'name': '蓝海房车'
      },
      {
        'id': 132,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_166_55.png',
        'name': '理念'
      },
      {
        'id': 133,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_249_55.png',
        'name': '陆地方舟'
      },
      {
        'id': 134,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_255_55.png',
        'name': 'LeSEE'
      },
      {
        'id': 135,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_101_55.png',
        'name': '罗孚'
      },
      {
        'id': 136,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_223_55.png',
        'name': '领志'
      },
      {
        'id': 137,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_227_55.png',
        'name': '朗世'
      }
    ],
    'M': [
      {
        'id': 138,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_18_55.png',
        'name': '马自达'
      },
      {
        'id': 139,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_79_55.png',
        'name': 'MG'
      },
      {
        'id': 140,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_93_55.png',
        'name': '玛莎拉蒂'
      },
      {
        'id': 141,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_81_55.png',
        'name': 'MINI'
      },
      {
        'id': 142,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_183_55.png',
        'name': '迈凯伦'
      },
      {
        'id': 143,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_88_55.png',
        'name': '迈巴赫'
      },
      {
        'id': 144,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_201_55.png',
        'name': '摩根'
      },
      {
        'id': 145,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_55_55.png',
        'name': '美亚'
      }
    ],
    'N': [
      {
        'id': 146,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_155_55.png',
        'name': '纳智捷'
      },
      {
        'id': 147,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_234_55.png',
        'name': 'Noble'
      }
    ],
    'O': [
      {
        'id': 148,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_84_55.png',
        'name': '讴歌'
      },
      {
        'id': 149,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_104_55.png',
        'name': '欧宝'
      },
      {
        'id': 150,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_171_55.png',
        'name': '欧朗'
      },
      {
        'id': 151,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_243_55.png',
        'name': '欧联'
      }
    ],
    'P': [
      {
        'id': 152,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_185_55.png',
        'name': '帕加尼'
      },
      {
        'id': 153,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_210_55.png',
        'name': '皮特比尔特卡车'
      },
      {
        'id': 154,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_191_55.png',
        'name': 'PGO'
      },
      {
        'id': 155,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_105_55.png',
        'name': '旁蒂克'
      }
    ],
    'Q': [
      {
        'id': 41,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_156_55.png',
        'name': '启辰'
      },
      {
        'id': 156,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_28_55.png',
        'name': '起亚'
      },
      {
        'id': 157,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_42_55.png',
        'name': '奇瑞'
      },
      {
        'id': 158,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_43_55.png',
        'name': '庆铃'
      },
      {
        'id': 159,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_226_55.png',
        'name': '乔治·巴顿'
      }
    ],
    'R': [
      {
        'id': 160,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_30_55.png',
        'name': '日产'
      },
      {
        'id': 161,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_78_55.png',
        'name': '荣威'
      },
      {
        'id': 162,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_142_55.png',
        'name': '瑞麒'
      }
    ],
    'S': [
      {
        'id': 163,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_25_55.png',
        'name': '三菱'
      },
      {
        'id': 164,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_10_55.png',
        'name': '斯柯达'
      },
      {
        'id': 165,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_111_55.png',
        'name': '斯巴鲁'
      },
      {
        'id': 166,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_165_55.png',
        'name': '上汽大通MAXUS'
      },
      {
        'id': 167,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_102_55.png',
        'name': '双龙'
      },
      {
        'id': 168,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_89_55.png',
        'name': 'smart'
      },
      {
        'id': 169,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_260_55.png',
        'name': 'SWM斯威汽车'
      },
      {
        'id': 170,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_209_55.png',
        'name': '山姆'
      },
      {
        'id': 171,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_242_55.png',
        'name': 'STARTECH'
      },
      {
        'id': 172,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_50_55.png',
        'name': '双环'
      },
      {
        'id': 173,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_239_55.png',
        'name': '赛麟SALEEN'
      },
      {
        'id': 174,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_137_55.png',
        'name': '世爵'
      },
      {
        'id': 175,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_103_55.png',
        'name': '萨博'
      },
      {
        'id': 176,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_169_55.png',
        'name': '陕汽通家'
      },
      {
        'id': 177,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_244_55.png',
        'name': '上喆汽车'
      },
      {
        'id': 178,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_117_55.png',
        'name': '三星'
      },
      {
        'id': 179,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_73_55.png',
        'name': '顺旅'
      }
    ],
    'T': [
      {
        'id': 180,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_189_55.png',
        'name': '特斯拉'
      },
      {
        'id': 181,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_175_55.png',
        'name': '腾势'
      },
      {
        'id': 182,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_202_55.png',
        'name': '泰卡特'
      },
      {
        'id': 183,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_54_55.png',
        'name': '天马'
      },
      {
        'id': 184,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_56_55.png',
        'name': '通田'
      }
    ],
    'W': [
      {
        'id': 185,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_48_55.png',
        'name': '五菱'
      },
      {
        'id': 186,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_19_55.png',
        'name': '沃尔沃'
      },
      {
        'id': 187,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_132_55.png',
        'name': '五十铃'
      },
      {
        'id': 188,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_207_55.png',
        'name': '潍柴英致'
      },
      {
        'id': 189,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_270_55.png',
        'name': 'WEY'
      },
      {
        'id': 190,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_140_55.png',
        'name': '威麟'
      },
      {
        'id': 191,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_266_55.png',
        'name': '蔚来'
      },
      {
        'id': 192,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_186_55.png',
        'name': '威兹曼'
      },
      {
        'id': 193,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_247_55.png',
        'name': '潍柴欧睿'
      },
      {
        'id': 194,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_46_55.png',
        'name': '万丰'
      }
    ],
    'X': [
      {
        'id': 195,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_13_55.png',
        'name': '现代'
      },
      {
        'id': 196,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_49_55.png',
        'name': '雪佛兰'
      },
      {
        'id': 197,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_6_55.png',
        'name': '雪铁龙'
      },
      {
        'id': 198,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_174_55.png',
        'name': '星客特'
      },
      {
        'id': 199,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_71_55.png',
        'name': '新凯'
      },
      {
        'id': 200,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_87_55.png',
        'name': '西雅特'
      },
      {
        'id': 201,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_264_55.png',
        'name': '小鹏汽车'
      },
      {
        'id': 202,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_62_55.png',
        'name': '新雅途'
      },
      {
        'id': 203,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_65_55.png',
        'name': '新大地'
      }
    ],
    'Y': [
      {
        'id': 204,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_53_55.png',
        'name': '一汽'
      },
      {
        'id': 205,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_100_55.png',
        'name': '英菲尼迪'
      },
      {
        'id': 206,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_258_55.png',
        'name': '驭胜'
      },
      {
        'id': 207,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_138_55.png',
        'name': '野马汽车'
      },
      {
        'id': 208,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_41_55.png',
        'name': '依维柯'
      },
      {
        'id': 209,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_178_55.png',
        'name': '宇通'
      },
      {
        'id': 210,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_75_55.png',
        'name': '永源'
      },
      {
        'id': 211,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_238_55.png',
        'name': '御捷'
      },
      {
        'id': 212,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_245_55.png',
        'name': '游侠汽车'
      },
      {
        'id': 213,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_268_55.png',
        'name': '雅宾纳'
      },
      {
        'id': 214,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_118_55.png',
        'name': '云豹'
      },
      {
        'id': 215,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_126_55.png',
        'name': '云雀'
      },
      {
        'id': 216,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_194_55.png',
        'name': '扬州亚星客车'
      },
      {
        'id': 217,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_47_55.png',
        'name': '仪征'
      }
    ],
    'Z': [
      {
        'id': 218,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_77_55.png',
        'name': '众泰'
      },
      {
        'id': 219,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_60_55.png',
        'name': '中华'
      },
      {
        'id': 220,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_233_55.png',
        'name': '知豆'
      },
      {
        'id': 221,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_33_55.png',
        'name': '中兴'
      },
      {
        'id': 222,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_167_55.png',
        'name': '中欧奔驰房车'
      },
      {
        'id': 223,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_214_55.png',
        'name': '浙江卡尔森'
      },
      {
        'id': 224,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_203_55.png',
        'name': '之诺'
      },
      {
        'id': 225,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_246_55.png',
        'name': '重汽王牌'
      },
      {
        'id': 226,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_204_55.png',
        'name': '中通客车'
      },
      {
        'id': 227,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_72_55.png',
        'name': '中顺'
      },
      {
        'id': 228,
        'image_url': 'http://image.bitautoimg.com/bt/car/default/images/logo/masterbrand/png/55/m_64_55.png',
        'name': '中客华北'
      }
    ]
  },
  'code': 0,
  'message': 'ok'
})
Mock.mock(/auctions\/car_models\/brands\/\d+\/series$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'series': [
    {
      'id': 1,
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L'
    },
    {
      'id': 2,
      'manufacturer': '一汽奥迪',
      'name': '奥迪A6L'
    },
    {
      'id': 3,
      'manufacturer': '一汽奥迪',
      'name': '奥迪Q5'
    },
    {
      'id': 4,
      'manufacturer': '一汽奥迪',
      'name': '奥迪A3'
    },
    {
      'id': 5,
      'manufacturer': '一汽奥迪',
      'name': '奥迪Q3'
    },
    {
      'id': 6,
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4'
    },
    {
      'id': 7,
      'manufacturer': '一汽奥迪',
      'name': '奥迪100'
    },
    {
      'id': 8,
      'manufacturer': '一汽奥迪',
      'name': '奥迪200'
    },
    {
      'id': 9,
      'manufacturer': '进口奥迪',
      'name': '奥迪Q7(进口)'
    },
    {
      'id': 10,
      'manufacturer': '进口奥迪',
      'name': '奥迪A8L(进口)'
    },
    {
      'id': 11,
      'manufacturer': '进口奥迪',
      'name': '奥迪A7(进口)'
    },
    {
      'id': 12,
      'manufacturer': '进口奥迪',
      'name': '奥迪A5(进口)'
    },
    {
      'id': 13,
      'manufacturer': '进口奥迪',
      'name': '奥迪R8(进口)'
    },
    {
      'id': 14,
      'manufacturer': '进口奥迪',
      'name': '奥迪TT(进口)'
    },
    {
      'id': 15,
      'manufacturer': '进口奥迪',
      'name': '奥迪Q5(进口)'
    },
    {
      'id': 16,
      'manufacturer': '进口奥迪',
      'name': '奥迪A1(进口)'
    },
    {
      'id': 17,
      'manufacturer': '进口奥迪',
      'name': '奥迪A4 allroad'
    },
    {
      'id': 18,
      'manufacturer': '进口奥迪',
      'name': '奥迪S8(进口)'
    },
    {
      'id': 19,
      'manufacturer': '进口奥迪',
      'name': '奥迪S3'
    },
    {
      'id': 20,
      'manufacturer': '进口奥迪',
      'name': '奥迪A3(进口)'
    },
    {
      'id': 21,
      'manufacturer': '进口奥迪',
      'name': '奥迪A6(进口)'
    },
    {
      'id': 22,
      'manufacturer': '进口奥迪',
      'name': '奥迪A6 allroad'
    },
    {
      'id': 23,
      'manufacturer': '进口奥迪',
      'name': '奥迪SQ5(进口)'
    },
    {
      'id': 24,
      'manufacturer': '进口奥迪',
      'name': '奥迪S5(进口)'
    },
    {
      'id': 25,
      'manufacturer': '进口奥迪',
      'name': '奥迪S7(进口)'
    },
    {
      'id': 26,
      'manufacturer': '进口奥迪',
      'name': '奥迪S6(进口)'
    },
    {
      'id': 27,
      'manufacturer': '进口奥迪',
      'name': '奥迪Q3(进口)'
    },
    {
      'id': 28,
      'manufacturer': '进口奥迪',
      'name': 'A3 e-tron'
    },
    {
      'id': 29,
      'manufacturer': '进口奥迪',
      'name': '奥迪S4'
    },
    {
      'id': 30,
      'manufacturer': '进口奥迪',
      'name': '奥迪Q2'
    },
    {
      'id': 31,
      'manufacturer': '进口奥迪',
      'name': '奥迪Q8'
    },
    {
      'id': 32,
      'manufacturer': '进口奥迪',
      'name': '奥迪Q1(进口)'
    },
    {
      'id': 33,
      'manufacturer': '进口奥迪',
      'name': '奥迪A4(进口)'
    },
    {
      'id': 34,
      'manufacturer': '进口奥迪',
      'name': '奥迪S1(进口)'
    },
    {
      'id': 35,
      'manufacturer': '进口奥迪RS',
      'name': '奥迪RS7(进口)'
    },
    {
      'id': 36,
      'manufacturer': '进口奥迪RS',
      'name': '奥迪RS6(进口)'
    },
    {
      'id': 37,
      'manufacturer': '进口奥迪RS',
      'name': '奥迪RS5(进口)'
    }
  ]
})
Mock.mock(/auctions\/car_models\/series\/\d+\/models$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'models': [
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 1,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 40 TFSI 进取型',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 2,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 40 TFSI 时尚型',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 3,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 40 TFSI 风尚型',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 4,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 40 TFSI 运动型',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 5,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 45 TFSI quattro 风尚型',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 6,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 45 TFSI quarrto 运动型',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 7,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 45 TFSI quarrto 特别版',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 8,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 30 TFSI 手动 舒适型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 9,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 30 TFSI 自动 舒适型 典藏版',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 10,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 30 TFSI 自动 舒适型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 11,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 35 TFSI 自动 标准型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 12,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 35 TFSI 自动 标准型 典藏版',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 13,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 35 TFSI 自动 舒适型 S line 典藏版',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 14,
      'image_url': 'http://img3.bitautoimg.com/autoalbum/files/20151126/529/11171252955440_4371786_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 35 TFSI 自动 舒适型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 15,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 35 TFSI 自动 运动型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 16,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 35 TFSI 自动 技术型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 17,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 35 TFSI 自动 豪华型 S line 典藏版',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 18,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 35 TFSI 自动 豪华型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 19,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 45 TFSI quattro 个性运动型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 20,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 45 TFSI quattro 个性运动型 典藏版',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 21,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 45 TFSI quattro 运动型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '3.0',
      'id': 22,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2016款 50 TFSI quattro 旗舰型',
      'series': '奥迪A4L',
      'year': 2016
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 23,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20160425/819/12362981949340_5174955_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 30 TFSI 手动 舒适型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 24,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20140708/378/16102537873810_3440611_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 30 TFSI 自动 舒适型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 25,
      'image_url': 'http://img1.bitautoimg.com/autoalbum/files/20150706/786/15351178609584_4141612_2.JPG',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 35 TFSI 纪念智领版',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 26,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 35 TFSI 自动 标准型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 27,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 35 TFSI 纪念舒享版',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 28,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 35 TFSI 自动 舒适型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 29,
      'image_url': 'http://img1.bitautoimg.com/autoalbum/files/20141021/489/16381948913810_3675380_2.JPG',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 35 TFSI 自动 技术型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 30,
      'image_url': 'http://img1.bitautoimg.com/autoalbum/files/20150828/033/11063303378993_4230708_2.JPG',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 35 TFSI 自动 豪华型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 31,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 45 TFSI quattro 个性运动型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 32,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 45 TFSI quattro 运动型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '3.0',
      'id': 33,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2015款 50 TFSI quattro 旗舰型',
      'series': '奥迪A4L',
      'year': 2015
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 34,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20120816/450/09450245019874_2295279_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 30 TFSI 手动 舒适型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 35,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20120816/450/09450245019874_2295279_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 30 TFSI 自动 舒适型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 36,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20120816/450/09450245019874_2295279_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 35 TFSI 自动 标准型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 37,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20120816/450/09450245019874_2295279_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 35 TFSI 自动 舒适型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 38,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20120816/450/09450245019874_2295279_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 35 TFSI 自动 技术型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 39,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20120816/450/09450245019874_2295279_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 35 TFSI 自动 豪华型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 40,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 40 TFSI quattro 个性运动型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 41,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20120816/450/09450245019874_2295279_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 40 TFSI quattro 运动型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '3.0',
      'id': 42,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20120816/450/09450245019874_2295279_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2013款 50 TFSI quattro 旗舰型',
      'series': '奥迪A4L',
      'year': 2013
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 43,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2012款 1.8 TFSI 手动 舒适型',
      'series': '奥迪A4L',
      'year': 2012
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 44,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2012款 1.8 TFSI 自动 舒适型',
      'series': '奥迪A4L',
      'year': 2012
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 45,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20111223/382/15502238225971_1776363_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2012款 2.0 TFSI(132kW) 标准型',
      'series': '奥迪A4L',
      'year': 2012
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 46,
      'image_url': 'http://img1.bitautoimg.com/autoalbum/files/20111223/178/16110417846117_1776724_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2012款 2.0 TFSI(132kW) 舒适型',
      'series': '奥迪A4L',
      'year': 2012
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 47,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20111223/291/15445229129874_1776247_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2012款 2.0 TFSI(132kW) 技术型',
      'series': '奥迪A4L',
      'year': 2012
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 48,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2012款 2.0 TFSI(132kW) 豪华型',
      'series': '奥迪A4L',
      'year': 2012
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 49,
      'image_url': 'http://img4.bitautoimg.com/autoalbum/files/20111223/783/16165978301432_1776763_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2012款 2.0 TFSI(155kW) 运动型',
      'series': '奥迪A4L',
      'year': 2012
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 50,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2012款 2.0 TFSI(155kW) 尊享型',
      'series': '奥迪A4L',
      'year': 2012
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 51,
      'image_url': 'http://img1.bitautoimg.com/autoalbum/files/20110923/868/18125786824730_1678020_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2011款 1.8 TFSI 舒适型',
      'series': '奥迪A4L',
      'year': 2011
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 52,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2011款 2.0 TFSI(132kW) 标准型',
      'series': '奥迪A4L',
      'year': 2011
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 53,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2011款 2.0 TFSI(132kW) 舒适型',
      'series': '奥迪A4L',
      'year': 2011
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 54,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2011款 2.0 TFSI(132kW) 技术型',
      'series': '奥迪A4L',
      'year': 2011
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 55,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2011款 2.0 TFSI(132kW) 豪华型',
      'series': '奥迪A4L',
      'year': 2011
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 56,
      'image_url': 'http://img3.bitautoimg.com/autoalbum/files/20110504/772/19405177226770_1575898_2.JPG',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2011款 2.0 TFSI(155kW) 运动型',
      'series': '奥迪A4L',
      'year': 2011
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 57,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2011款 2.0 TFSI(155kW) 尊享型',
      'series': '奥迪A4L',
      'year': 2011
    },
    {
      'brand': '奥迪',
      'displacement': '3.2',
      'id': 58,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2011款 3.2 FSI quattro 旗舰型',
      'series': '奥迪A4L',
      'year': 2011
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 59,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2010款 1.8 TFSI 手动舒适型',
      'series': '奥迪A4L',
      'year': 2010
    },
    {
      'brand': '奥迪',
      'displacement': '1.8',
      'id': 60,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2010款 1.8TFSI 舒适型',
      'series': '奥迪A4L',
      'year': 2010
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 61,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2010款 2.0TFSI 标准型',
      'series': '奥迪A4L',
      'year': 2010
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 62,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2010款 2.0TFSI 舒适型',
      'series': '奥迪A4L',
      'year': 2010
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 63,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2010款 2.0TFSI 技术型',
      'series': '奥迪A4L',
      'year': 2010
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 64,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2010款 2.0TFSI 豪华型',
      'series': '奥迪A4L',
      'year': 2010
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 65,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2010款 2.0TFSI 运动型',
      'series': '奥迪A4L',
      'year': 2010
    },
    {
      'brand': '奥迪',
      'displacement': '3.2',
      'id': 66,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2010款 3.2FSI quattro 旗舰型',
      'series': '奥迪A4L',
      'year': 2010
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 67,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2009款 2.0 TFSI 标准型',
      'series': '奥迪A4L',
      'year': 2009
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 68,
      'image_url': 'http://img1.bitautoimg.com/autoalbum/files/carstandard/a4l/55c541dd-c63a-49e1-9909-41eb8e40fdee_237556_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2009款 2.0 TFSI 舒适型',
      'series': '奥迪A4L',
      'year': 2009
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 69,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2009款 2.0 TFSI 技术型',
      'series': '奥迪A4L',
      'year': 2009
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 70,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20100629/296/1056022968_1351701_2.JPG',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2009款 2.0 TFSI 豪华型',
      'series': '奥迪A4L',
      'year': 2009
    },
    {
      'brand': '奥迪',
      'displacement': '3.2',
      'id': 71,
      'image_url': 'http://img1.bitautoimg.com/autoalbum/files/20100629/796/1059027968_1351812_2.JPG',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2009款 3.2 FSI quattro 旗舰型',
      'series': '奥迪A4L',
      'year': 2009
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 29729,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 40 TFSI 进取型 Plus',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 29730,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 40 TFSI 时尚型 Plus',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 29731,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 40 TFSI 运动型 Plus',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 29732,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 40 TFSI 风尚型 Plus',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 29733,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 45 TFSI quarrto 运动型 Plus',
      'series': '奥迪A4L',
      'year': 2017
    },
    {
      'brand': '奥迪',
      'displacement': '2.0',
      'id': 29734,
      'image_url': 'http://img2.bitautoimg.com/autoalbum/files/20170407/958/16325395873602_5454777_2.jpg',
      'manufacturer': '一汽奥迪',
      'name': '奥迪A4L 2017款 45 TFSI quattro 风尚型 Plus',
      'series': '奥迪A4L',
      'year': 2017
    }
  ]
})
Mock.mock(/auctions\/car_models$/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'brand': '奥迪',
    'extinfo': {
      'displacement': '2.0',
      'emission_standard': '国五',
      'engine_type': '涡轮增压',
      'fuel_type': '汽油',
      'gearbox': 'DSG双离合',
      'guide_price': '29.98万',
      'level': '中型车'
    },
    'id': 1,
    'manufacturer': '一汽奥迪',
    'name': '奥迪A4L 2017款 40 TFSI 进取型',
    'serie': '奥迪A4L',
    'year': 2017
  },
  'message': 'ok'
})
// 客户列表
Mock.mock(/sales_receptions\/customers/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'customer_infos': [
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196', 'ES7826196', 'ES7826196', 'ES7826196', 'ES7826196', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      },
      {
        'customer_mobile': 18998989898,
        'customer_name': '陈放放',
        'plate_number': [
          'ES9001', 'ES7826196'
        ],
        'latest_visited_at': '7月30日',
        id: 1
      }

    ],
    'total_count': 50
  },
  'message': 'ok'
})

// 获取销售接待设置
Mock.mock(/sales_receptions\/configs/, 'get' + mockSwitch, {
  'code': 0,
  'message': '成功信息',
  'data': {
    'total_count': 15,
    'configs': [{
      'id': 1,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试1'
    },
    {
      'id': 2,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试2'
    },
    {
      'id': 3,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试3'
    },
    {
      'id': 4,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试4'
    },
    {
      'id': 5,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试5'
    },
    {
      'id': 6,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试6'
    },
    {
      'id': 7,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试7'
    },
    {
      'id': 8,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试8'
    },
    {
      'id': 9,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试9'
    },
    {
      'id': 10,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试10'
    },
    {
      'id': 11,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试11'
    },
    {
      'id': 12,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试12'
    },
    {
      'id': 13,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试13'
    },
    {
      'id': 14,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试14'
    },
    {
      'id': 15,
      'update_at': '2020-10-09 15:00',
      'creator_name': 'owen-sun',
      'name': '这是一个配置测试15'
    }
    ]
  }
})
